module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemId),
      expression: "systemId"
    }],
    staticClass: "form-control mr-2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.systemId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("選擇系統")]), _vm._l((_vm.systems), function(sys) {
    return _c('option', {
      domProps: {
        "value": sys.id
      }
    }, [_vm._v(_vm._s(sys.name))])
  })], 2), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('hr'), _c('div', {
    attrs: {
      "id": "planning-table"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/refill-order/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "medication-name",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.rowData.drug_storage.medication.code) + " - " + _vm._s(props.rowData.drug_storage.medication.generic_name))])]
      }
    }, {
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock))])]
      }
    }, {
      key: "refill-box",
      fn: function(props) {
        return [(props.rowData.drug_storage.medication.pack_content === 0) ? _c('span', [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) + " pc")]) : _c('span', [_vm._v(_vm._s(Math.floor((props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) / props.rowData.drug_storage.medication.pack_content)) + " 盒 " + _vm._s((props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) % props.rowData.drug_storage.medication.pack_content) + " pc")])]
      }
    }])
  })], 1), _c('button', {
    staticClass: "btn btn-primary mr-2",
    on: {
      "click": _vm.deleteOrder
    }
  }, [_vm._v("刪除補藥項目")]), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.outputTable
    }
  }, [_vm._v("下載報告")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("待補藥清單"), _c('small', [_vm._v("（已列入為補藥規劃")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c019d7b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/PlanningList.vue
// module id = 1541
// module chunks = 1